<template>
  <div
    @click.stop.prevent
    class="c-buttonPurchase"
  >
    <!-- isWaitingReservableのボタン -->
    <div
      v-if="isWaitingReservable"
      :class="{ 'c-buttonPurchase-waitingReservable' : isWaitingReservable }"
    >
      <div class="c-buttonPurchase_button">
        <c-button-v2
          :color="purchaseButtonColor"
          :size="buttonSize"
          :disabled="purchaseButtonIsDisable"
          @click="clickPurchaseBotton($event, true)"
          width="100%"
        >
          <coconala-icon
            :name="purchaseButtonIcon"
            v-if="isPC"
          />
          {{ isPC ? purchaseButtonStatus.text : purchaseButtonStatus.textSp }}
        </c-button-v2>
      </div>

      <div class="c-buttonPurchase_button c-buttonPurchase_waitingReservable">
        <c-button-v2
          :color="purchaseButtonStatus.colorReservable"
          :size="buttonSize"
          @click="clickPurchaseBotton($event)"
          width="100%"
        >
          <coconala-icon
            :name="purchaseButtonStatus.iconReservable"
            v-if="isPC"
          />
          {{ isPC ? purchaseButtonStatus.textReservable : purchaseButtonStatus.textReservableSp }}
        </c-button-v2>
      </div>
    </div>

    <!-- isWaitingReservable以外のボタン -->
    <div
      class="c-buttonPurchase_button"
      v-else
    >
      <c-button-v2
        :color="purchaseButtonColor"
        :size="buttonSize"
        :disabled="purchaseButtonIsDisable"
        @click="clickPurchaseBotton($event)"
        width="100%"
      >
        <coconala-icon :name="purchaseButtonStatus.icon" />
        {{ purchaseButtonText }}
      </c-button-v2>
    </div>

    <!-- 多重購入警告モーダル -->
    <c-modal
      title="購入に進む"
      class="c-inProgressServiceModal"
      :active="showInProgressServiceModal"
      @close="closeInProgressServiceModal"
    >
      <div class="c-inProgressServiceModal_inner">
        <div class="c-inProgressServiceModal_text">
          このサービスはすでに購入済みです。<br>
          追加購入の場合はこのままお進みください。
        </div>
        <div class="c-inProgressServiceModal_buttons">
          <c-button
            color="thirdly"
            size="medium"
            @click="closeInProgressServiceModal"
          >
            戻る
          </c-button>
          <c-button
            color="primary-green"
            size="medium"
            @click="clickDuplicatePurchaseConfirmedBotton($event)"
          >
            このまま進む
          </c-button>
        </div>
        <div
          class="c-inProgressServiceModal_toTalkroom"
          v-if="serviceDetail.buyer.openServiceTalkroomId"
        >
          <a
            href="javascript:;"
            @click="clickTalkrooms(serviceDetail.buyer.openServiceTalkroomId)"
          >取引中のトークルームに移動</a>
        </div>
      </div>
    </c-modal>
  </div>
</template>
<script>
const PURCHASE_BUTTON_STATUS_LIST = {
  incompatible: {
    color: 'primary',
    text: '対応不可',
    icon: 'slash-circle-o',
    isDisable: true
  },
  waiting: {
    color: 'primary-blue',
    text: 'すぐに電話する',
    icon: 'phone',
    isDisable: false
  },
  waiting_reservable: {
    color: 'primary-blue',
    colorReservable: 'primary',
    text: 'すぐに電話する',
    textReservable: '電話予約を申込む',
    textSp: 'すぐに電話',
    textReservableSp: '予約申込み',
    icon: 'phone',
    iconReservable: 'calender',
    isDisable: false
  },
  waiting_only: {
    color: 'primary',
    text: '待機中のみ受付可',
    icon: 'slash-circle-o',
    isDisable: true
  },
  reservable_only: {
    color: 'primary',
    text: '電話予約を申込む',
    textSp: '予約申込み',
    icon: 'calender',
    isDisable: false
  },
  stop: {
    color: 'primary',
    text: '受付休止中',
    icon: 'slash-circle-o',
    isDisable: true
  },
  busy: {
    color: 'primary',
    text: '少々お待ち下さい',
    icon: 'slash-circle-o',
    isDisable: true
  },
  full_correspondence: {
    color: 'primary',
    text: '満枠対応中',
    icon: 'slash-circle-o',
    isDisable: true
  },
  available: {
    color: 'primary',
    text: '購入画面に進む',
    icon: 'cart',
    isDisable: false
  },
  archive: {
    color: 'primary',
    text: '受付終了',
    icon: '',
    isDisable: true
  },
  not_video_supported_device: {
    color: 'primary',
    text: '購入画面に進む',
    icon: 'cart',
    isDisable: true
  }
}

// vuex
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  name: 'ButtonPurchase',
  props: {
    buttonSize: {
      type: String,
      default: 'l'
    },
    serviceDetail: {
      type: Object,
      required: true
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      purchaseParams: {},
      showInProgressServiceModal: false,
      purchaseButtonStatusList: PURCHASE_BUTTON_STATUS_LIST
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapGetters('ui', ['isPC', 'isTB', 'isSP']),
    isWaitingReservable() {
      return this.serviceDetail.serviceDetail.purchaseStatus === 'waiting_reservable'
    },
    purchaseButtonStatus() {
      let status = this.serviceDetail.serviceDetail.purchaseStatus
      if (!status) {
        status = 'stop'
      }
      return this.purchaseButtonStatusList[status]
    },
    purchaseButtonColor() {
      return this.purchaseButtonStatus.color
    },
    purchaseButtonText() {
      if ((this.isSP || this.isTB) && this.purchaseButtonStatus.textSp) {
        return this.purchaseButtonStatus.textSp
      }
      return this.purchaseButtonStatus.text
    },
    purchaseButtonIcon() {
      return this.purchaseButtonStatus.icon
    },
    purchaseButtonIsDisable() {
      return this.purchaseButtonStatus.isDisable
    }
  },
  methods: {
    ...mapActions('ui', ['showLoginModal']),
    clickPurchaseBotton(e, instant = false) {
      // オーダーのパラメータを作成
      const params = {
        service_id: this.serviceDetail.serviceDetail.id,
        option_ids: this.options
      }
      if (this.serviceDetail.serviceDetail.purchaseStatus === 'waiting' || instant) {
        params['instant'] = 1
      }
      this.purchaseParams = params

      // 非ログインの場合はログインモーダルを表示
      if (!this.isLoggedIn) {
        e.preventDefault()
        this.showLoginModal()
        return
      }

      // 購入済みサービスの場合は多重購入防止モーダルを表示
      if (this.serviceDetail.buyer.isInProgressService) {
        this.showInProgressServiceModal = true
        return
      }

      location.href = this.$coconala.servicePurchaseUrl(this.purchaseParams)
    },
    clickDuplicatePurchaseConfirmedBotton() {
      location.href = this.$coconala.servicePurchaseUrl(this.purchaseParams)
    },
    closeInProgressServiceModal() {
      this.showInProgressServiceModal = false
    },
    clickTalkrooms(id) {
      location.href = `/talkrooms/${id}`
    }
  }
}
</script>
<style lang="scss" scoped>
.c-buttonPurchase {
  &_waitingReservable {
    margin-top: 8px;
  }
}
.c-inProgressServiceModal {
  &_inner {
    margin: 0 auto;
    padding: 24px;
    text-align: center;
  }

  &_text {
    display: inline-block;
    max-width: 320px;
    margin-bottom: 24px;
    text-align: left;
  }

  &_buttons {
    margin-bottom: 12px;

    /deep/ .button {
      &.is-medium {
        width: 120px;
        @include link-effect;

        & + .is-medium {
          margin-left: 20px;
        }

        span {
          font-size: 13px;
        }
      }
    }
  }
}

/deep/ .c-modal {
  &_inner {
    width: 600px;
    max-width: 95%;
    margin: 0 auto;
  }
}

@media (max-width: breakpoint(ServiceDetail, M)) {
  .c-buttonPurchase {
    &-waitingReservable {
      display: flex;
      justify-content: space-between;
    }

    &_button {
      flex: 1 1 auto;
    }

    &_waitingReservable {
      margin-top: 0;
      margin-left: 8px;
    }
  }

  /deep/ .c-buttonV2 {
    &.is-m {
      padding: 0 4px;
    }
  }

  .c-inProgressServiceModal {
    &_inner {
      padding: 24px 0;
    }
  }

  /deep/ .c-modal {
    &_inner {
      width: auto;
    }
  }
}
</style>
